// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidden-element {
  visibility: hidden;
}

.msg-thread-empty {
  width: 150px;
  height: 150px;
  background-color: #24b7c7;
  border-radius: 50%;
}
.msg-thread-empty .mat-icon {
  width: 105px;
  height: 105px;
  line-height: 105px;
  text-align: center;
  font-size: 100px;
}

.msg-thread-header {
  width: 100%;
  min-height: 68px;
  background-color: white;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.msg-thread-header .msg-thread-title {
  display: inline-block;
  margin: 10px;
}

.msg-thread-messages-list {
  overflow-y: auto;
  overflow-x: hidden;
}
.msg-thread-messages-list .msg-thread-message-container {
  padding: 10px;
}
.msg-thread-messages-list .msg-thread-message-container.first-of-group {
  padding-bottom: 2px;
}
.msg-thread-messages-list .msg-thread-message-container.last-of-group {
  padding-top: 2px;
}
.msg-thread-messages-list .msg-thread-message-container.middle-of-group {
  padding-bottom: 2px;
  padding-top: 2px;
}
.msg-thread-messages-list .msg-thread-message-container .msg-thread-message-content {
  max-width: 80%;
  background-color: #e0e0e0;
  border-radius: 20px;
}
.msg-thread-messages-list .msg-thread-message-container .msg-thread-message-content.first-of-group:not(.msg-thread-message-content-other) {
  border-bottom-right-radius: 5px;
  padding-bottom: 2px;
}
.msg-thread-messages-list .msg-thread-message-container .msg-thread-message-content.last-of-group:not(.msg-thread-message-content-other) {
  border-top-right-radius: 5px;
  padding-top: 2px;
}
.msg-thread-messages-list .msg-thread-message-container .msg-thread-message-content.middle-of-group:not(.msg-thread-message-content-other) {
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
  padding-bottom: 2px;
  padding-top: 2px;
}
.msg-thread-messages-list .msg-thread-message-container .msg-thread-message-content .msg-thread-message-content-text {
  font-size: 13px;
  white-space: pre-wrap;
  color: rgba(0, 0, 0, 0.87);
}
.msg-thread-messages-list .msg-thread-message-container .msg-thread-message-content-other {
  background-color: #3c4252;
}
.msg-thread-messages-list .msg-thread-message-container .msg-thread-message-content-other.first-of-group {
  border-bottom-left-radius: 5px;
  padding-bottom: 2px;
}
.msg-thread-messages-list .msg-thread-message-container .msg-thread-message-content-other.last-of-group {
  border-top-left-radius: 5px;
  padding-top: 2px;
}
.msg-thread-messages-list .msg-thread-message-container .msg-thread-message-content-other.middle-of-group {
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
  padding-bottom: 2px;
  padding-top: 2px;
}
.msg-thread-messages-list .msg-thread-message-container .msg-thread-message-content-other .msg-thread-message-content-text {
  color: #fff;
  white-space: pre-wrap;
}
.msg-thread-messages-list .msg-thread-message-container .msg-thread-message-date {
  font-size: 11px;
  text-align: right;
  padding: 3px;
  color: rgba(0, 0, 0, 0.54);
}
.msg-thread-messages-list .msg-thread-message-container .msg-thread-message-date-other {
  font-size: 11px;
  text-align: left;
  padding: 3px;
  margin-left: 50px;
  color: rgba(0, 0, 0, 0.54);
}
.msg-thread-messages-list .msg-thread-message-container .msg-thread-message-delete {
  cursor: pointer;
  color: rgba(0, 0, 0, 0.3);
  margin-right: 10px;
}

.msg-thread-footer {
  background-color: #f5f5f5;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
.msg-thread-footer textarea {
  padding: 10px;
  background-color: white;
  resize: none;
  overflow-x: hidden;
  border: none;
  border-radius: 20px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}
.msg-thread-footer .mat-icon {
  position: absolute;
  bottom: 46px;
  right: 50px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/app/@modules/messaging/core/components/messaging-thread/messaging-thread.component.scss"],"names":[],"mappings":"AAKA;EACI,kBAAA;AAJJ;;AAOA;EAEI,YAAA;EACA,aAAA;EACA,yBAbc;EAcd,kBAAA;AALJ;AAOI;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AALR;;AASA;EAEI,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,4CAAA;AAPJ;AASI;EACI,qBAAA;EACA,YAAA;AAPR;;AAYA;EACI,gBAAA;EACA,kBAAA;AATJ;AAWI;EAEI,aAAA;AAVR;AAYQ;EACI,mBAAA;AAVZ;AAaQ;EACI,gBAAA;AAXZ;AAcQ;EACI,mBAAA;EACA,gBAAA;AAZZ;AAeQ;EAmBI,cAAA;EACA,yBAAA;EACA,mBAAA;AA/BZ;AAYY;EACI,+BAAA;EACA,mBAAA;AAVhB;AAaY;EACI,4BAAA;EACA,gBAAA;AAXhB;AAcY;EACI,+BAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;AAZhB;AAmBY;EACI,eAAA;EACA,qBAAA;EACA,0BAAA;AAjBhB;AAsBQ;EAmBI,yBAAA;AAtCZ;AAqBY;EACI,8BAAA;EACA,mBAAA;AAnBhB;AAsBY;EACI,2BAAA;EACA,gBAAA;AApBhB;AAuBY;EACI,8BAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;AArBhB;AA0BY;EAEI,WAAA;EACA,qBAAA;AAzBhB;AA8BQ;EACI,eAAA;EACA,iBAAA;EACA,YAAA;EACA,0BAAA;AA5BZ;AA+BQ;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,0BAAA;AA7BZ;AAgCQ;EACI,eAAA;EACA,yBAAA;EACA,kBAAA;AA9BZ;;AAoCA;EAEI,yBAAA;EACA,yCAAA;AAlCJ;AAoCI;EACI,aAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,+GAAA;AAlCR;AAqCI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;AAnCR","sourcesContent":["$validated-color: #24b7c7; \n$warning-color: #ED6723;\n$success-color: #679A00;\n$error-color:  darkred;\n\n.hidden-element {\n    visibility: hidden;\n}\n\n.msg-thread-empty {\n\n    width: 150px;\n    height: 150px;\n    background-color: $validated-color;\n    border-radius: 50%;\n\n    .mat-icon {\n        width: 105px;\n        height: 105px;\n        line-height: 105px;\n        text-align: center;\n        font-size: 100px;\n    }\n}\n\n.msg-thread-header {\n\n    width: 100%;\n    min-height: 68px;\n    background-color: white;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n\n    .msg-thread-title {\n        display:inline-block;\n        margin: 10px;\n    }\n\n}\n\n.msg-thread-messages-list {\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    .msg-thread-message-container {\n\n        padding: 10px;\n\n        &.first-of-group {\n            padding-bottom: 2px;\n        }\n\n        &.last-of-group {\n            padding-top: 2px;\n        }\n\n        &.middle-of-group {\n            padding-bottom: 2px;\n            padding-top: 2px;\n        }\n        \n        .msg-thread-message-content {\n\n            &.first-of-group:not(.msg-thread-message-content-other) {\n                border-bottom-right-radius: 5px;\n                padding-bottom: 2px;\n            }\n\n            &.last-of-group:not(.msg-thread-message-content-other) {\n                border-top-right-radius: 5px;\n                padding-top: 2px;\n            }\n\n            &.middle-of-group:not(.msg-thread-message-content-other) {\n                border-bottom-right-radius: 5px;\n                border-top-right-radius: 5px;\n                padding-bottom: 2px;\n                padding-top: 2px;\n            }\n\n            max-width: 80%;\n            background-color: #e0e0e0;\n            border-radius: 20px;\n\n            .msg-thread-message-content-text {\n                font-size: 13px;\n                white-space: pre-wrap;\n                color: rgba(0,0,0,.87);\n            }\n\n        }\n\n        .msg-thread-message-content-other {\n\n            &.first-of-group {\n                border-bottom-left-radius: 5px;\n                padding-bottom: 2px;\n            }\n\n            &.last-of-group {\n                border-top-left-radius: 5px;\n                padding-top: 2px;\n            }\n\n            &.middle-of-group {\n                border-bottom-left-radius: 5px;\n                border-top-left-radius: 5px;\n                padding-bottom: 2px;\n                padding-top: 2px;\n            }\n\n            background-color: #3c4252;\n\n            .msg-thread-message-content-text {\n                \n                color: #fff;\n                white-space: pre-wrap;\n            }\n\n        }\n\n        .msg-thread-message-date {\n            font-size: 11px;\n            text-align: right;\n            padding: 3px;\n            color: rgba(0,0,0,.54);\n        }\n\n        .msg-thread-message-date-other {\n            font-size: 11px;\n            text-align: left;\n            padding: 3px;\n            margin-left: 50px;\n            color: rgba(0,0,0,.54);\n        }\n    \n        .msg-thread-message-delete {\n            cursor: pointer;\n            color: rgba(0, 0, 0, 0.3);\n            margin-right: 10px;\n        }\n    }\n    \n}\n\n.msg-thread-footer {\n\n    background-color: #f5f5f5;\n    border-top: 1px solid rgba(0,0,0,.12);\n\n    textarea {\n        padding: 10px;\n        background-color: white;\n        resize: none;\n        overflow-x: hidden;\n        border: none;\n        border-radius: 20px;\n        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);\n    }\n\n    .mat-icon {\n        position: absolute; \n        bottom: 46px; \n        right: 50px;\n        cursor: pointer;\n        color: rgba(0, 0, 0, 0.3);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
